import { render, staticRenderFns } from "./List.vue?vue&type=template&id=9c119fe0&scoped=true&"
var script = {}
import style0 from "./List.vue?vue&type=style&index=0&id=9c119fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c119fe0",
  null
  
)

export default component.exports